function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.highlights-stroke,.primary{fill:none;}.white{fill:#fff;}.highlights-stroke{stroke:#e8dbec;stroke-miterlimit:10;}.highlights-stroke,.primary{stroke-linecap:round;stroke-width:16px;}.primary{stroke:#4f4954;stroke-linejoin:round;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("circle", {
  className: "white",
  cx: 120.43,
  cy: 67.82,
  r: 43.82
}), React.createElement("path", {
  className: "white",
  d: "M160,128a58.31,58.31,0,0,1,21.64,45.31C181.64,205.71,155,232,122.2,232s-59.44-26.29-59.44-58.72a58.44,58.44,0,0,1,25.24-48"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("path", {
  className: "highlights-stroke",
  d: "M141.94,24a44,44,0,0,1,0,88"
}), React.createElement("path", {
  className: "highlights-stroke",
  d: "M185.24,128a58.31,58.31,0,0,1,21.64,45.31c0,32.43-26.61,58.72-59.44,58.72"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("circle", {
  className: "primary",
  cx: 122.12,
  cy: 66.12,
  r: 42.12
}), React.createElement("path", {
  className: "primary",
  d: "M160,128a58.31,58.31,0,0,1,21.64,45.31C181.64,205.71,155,232,122.2,232s-59.44-26.29-59.44-58.72a58.44,58.44,0,0,1,25.24-48"
})));
var SvgTodoInPersonMeeting = function SvgTodoInPersonMeeting(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTodoInPersonMeeting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TodoInPersonMeeting.078fd19a.svg";
export { ForwardRef as ReactComponent };